import { render, staticRenderFns } from "./NovoChatSuporte.vue?vue&type=template&id=c78ca29c&scoped=true"
import script from "./NovoChatSuporte.vue?vue&type=script&lang=js"
export * from "./NovoChatSuporte.vue?vue&type=script&lang=js"
import style0 from "./NovoChatSuporte.vue?vue&type=style&index=0&id=c78ca29c&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c78ca29c",
  null
  
)

export default component.exports